<template>
    <div class="d-flex flex-1 h-100 overflow-hidden">
        <v-card class="report-container w-100 p-0" style="border-radius: 12px; margin-bottom: 24px">
            <v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Label_AuditActions" )}}</v-toolbar-title>
            </v-toolbar>

            <div class="border-top p-4 flex-1 overflow-auto">
                <div class="inputs-wrap">
                        <div>
                            <v-label>{{ $t("res_Label_ActionName") }} <span>*</span></v-label>
                            <v-text-field solo v-model="auditAction.actionName"></v-text-field>
                        </div>
                        <div>
                            <v-label>{{ $t("res_Label_Description") }}</v-label>
                            <v-textarea no-resize auto-grow v-model="auditAction.description" label="" class="light-bg p-0" :placeholder="$t('res_Label_defaultTextValue')"></v-textarea>
                        </div>
                        <div>
                            <v-label>{{ $t("res_Label_DescriptionArabic") }}</v-label>
                            <v-textarea no-resize auto-grow v-model="auditAction.descriptionAr" label="" class="light-bg p-0" :placeholder="$t('res_Label_defaultTextValue')"></v-textarea>
                        </div>
                    </div>
                <div class="d-flex align-items-end mt-4" style="width: 100%; justify-content: flex-end;">
                        <v-btn @click="clearAuditAction" color="mx-2 light-blue">{{ $t("res_ButtonText_Clear") }}</v-btn>
                        <v-btn @click="addAuditAction" color="primary">
                            {{ isEditing ? $t("res_ButtonText_UpdateAuditAction") : $t("res_ButtonText_AddAuditAction") }}
                        </v-btn>
                </div>

            <hr>    

            <v-data-table class="position-relative white flex-1 d-flex overflow-auto" header-fixed fixed-header :items="auditActions" :headers="headers" :mobile-breakpoint="0" disable-sort hide-default-footer>
                    <template v-slot:item="row">
                        <tr>
                            <td>{{ row.item.id }}</td>
                            <td>{{ row.item.actionName }}</td>
                            <td>{{ row.item.description }}</td>
                            <td>{{ row.item.descriptionAr }}</td>
                            <td class="text-start">
                                <div class="onhover-display">
                                    <div class="custom-icon-wrapper">
                                        <v-icon @click="setUpValues(row.item)">custom-icon white-bg edit-icon</v-icon>
                                    </div>
                                    <div class="custom-icon-wrapper">
                                        <v-icon @click="deleteAuditAction(row.item.id)">custom-icon white-bg delete-icon</v-icon>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
            </v-data-table>
            </div>
        </v-card>
    </div>
</template>


<script>
import axios from 'axios';
import constants from '@/assets/js/constants';

export default {
    name: "AuditActions",
    data() {
        return {
            auditActions: [],
            auditAction: {
                id: 0,
                actionName: "",
                description: "",
                descriptionAr: ""
            },
            headers: [
                { text: window.translate("res_GridHeaders_Id"), value: 'id', width: '50px'},
                { text: window.translate("res_GridHeaders_ActionName"), value: 'actionName', width: '250px'},
                { text: window.translate("res_GridHeaders_Description"), value: 'description', width: '400px'},
                { text: window.translate("res_GridHeaders_DescriptionAr"), value: 'descriptionAr', width: '500px'},
                { text: window.translate("res_GridHeaders_Actions"), value: 'actions', sortable: false, width: '100px'}
            ],
            isEditing: false
        }
    },
    methods: {
        backToAdminPage() {
            this.$router.push("/admin");
        },
        setUpValues(auditAction) {
            this.isEditing = true;
            this.auditAction = {
                id: auditAction.id,
                actionName: auditAction.actionName,
                description: auditAction.description,
                descriptionAr: auditAction.descriptionAr
            }
        },
        clearAuditAction() {
            this.auditAction = {
                actionName: "",
                description: "",
                descriptionAr: ""
            }
            this.isEditing = false;
        },
        async getAuditActions() {
            try {
                const response = await axios.get(constants.baseApiUrl + "Admin/GetAuditActions");
                this.auditActions = response.data;
            } catch (error) {
                console.log(error);
            }
        },
        async addAuditAction() {
            try {
                if(this.auditAction.actionName === "") return window.showAlert("res_Msgs_ActionNameRequired", "error");
                if(this.isEditing) return this.updateAuditAction();
                const response = await axios.post(constants.baseApiUrl + "Admin/InsertAuditAction", this.auditAction);
                if(response.data != null)
                {
                    window.showAlert("res_Msgs_AuditActionAddedSuccess", "success");
                    this.getAuditActions();
                    this.clearAuditAction();
                }
                else
                {
                    window.showAlert("res_Msgs_AuditActionAddedFailed", "error");
                }
            } catch (error) {
                console.log(error);
            }
        },
        async deleteAuditAction(id) {
            try {
                const response = await axios.post(constants.baseApiUrl + "Admin/DeleteAuditAction?id=" + id);
                if(response.data === 1)
                {
                    window.showAlert("res_Msgs_AuditAcitonDeletedSuccess", "success");
                    this.getAuditActions();
                }
                else
                {
                    window.showAlert("res_Msgs_AuditActionDeletedFailed", "error");
                }
            } catch (error) {
                console.log(error);
            }
        },
        async updateAuditAction() {
            try {
                const response = await axios.post(constants.baseApiUrl + "Admin/UpdateAuditAction", this.auditAction);
                if(response.data != null)
                {
                    window.showAlert("res_Msgs_AuditActionUpdatedSuccess", "success");
                    this.getAuditActions();
                    this.clearAuditAction();
                }
                else
                {
                    window.showAlert("res_Msgs_AuditActionUpdatedFailed", "error");
                }
            } catch (error) {
                console.log(error);
            }
        },
    },
    mounted() {
        this.getAuditActions();
    }
}
</script>/

<style scoped>
.inputs-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
}

.inputs-wrap > div {
    flex: 1;
}
</style>